<template>
  <v-card :loading="loading" :disabled="loading">
    <v-card-title>{{
      $t("pre_registration.registration_system")
    }}</v-card-title>
    <v-card-text class="px-0">
      <PageInfoPreRegis
        v-show="!loading && !error"
        v-if="DISPLAY_INFO_STATE.includes(state)"
        :all_page_states="PAGE_STATE"
        :page_state="state"
        :data_student_no_right="data_student_no_right"
      />

      <PreRegistrationPanel
        v-if="DISPLAY_REGISTRATION_PANEL_STATE.includes(state)"
        :all_page_states="PAGE_STATE"
        :page_state="state"
        :year="year"
        :semester="semester"
        :student_id="student_id"
      />
    </v-card-text>
    <v-card-text class="text-center" v-if="error">
      <h2>มีบางอย่างผิดพลาด</h2>
    </v-card-text>
  </v-card>
</template>

<script>
import RegistrationProvider from "@/services/registration.provider.js";
const RegistrationService = new RegistrationProvider();

// สถานะของหน้า
const PAGE_STATE = {
  DISPLAY_INFO_NOT_LOGGED_IN: "DISPLAY_INFO_NOT_LOGGED_IN",
  DISPLAY_INFO_NOT_IN_PRE_REGIS_PERIOD: "DISPLAY_INFO_NOT_IN_PRE_REGIS_PERIOD",
  DISPLAY_INFO_NOT_STUDY_STATUS: "DISPLAY_INFO_NOT_STUDY_STATUS",
  DISPLAY_INFO_NOT_FIRST_YEAR_FIRST_SEMESTER:
    "DISPLAY_INFO_NOT_FIRST_YEAR_FIRST_SEMESTER",
  DISPLAY_INFO_NO_RIGHT: "DISPLAY_INFO_NO_RIGHT",
  DISPLAY_INFO_NEVER_REGIS_AND_AFTER_PRE_REGIS_DATE:
    "DISPLAY_INFO_NEVER_REGIS_AND_AFTER_PRE_REGIS_DATE",
  DISPLAY_INFO_DEFAULT: "DISPLAY_INFO_DEFAULT",

  // หน้า pre regis มี 3 สถานะด้วยคือ 1.ยินยอม 2.กรอก 3.รอกดคอนเฟิร์ม
  // page หน้ากรอก มี 3 สถานะ คือ 1.มีช่องให้หรอก 2. ไม่มีช่องให้กรอก 3. ไม่มีช่องให้กรอก และมีผลการลงล่วงหน้า
  // ^ ยังเหลือเรื่อง Queue ที่จะต้องเพิ่มสถานะมาอีกทีหลัง
  PRE_REGIS: "PRE_REGIS", // หน้าทำการลงทะเบียนล่วงหน้า
  SUMMARY_PRE_REGIS: "SUMMARY_PRE_REGIS", // หน้าสรุปรายการลงทะเบียนล่วงหน้า
};
// สถานะใน PAGE_STATE ที่ใช้การแสดง PageInfoPreRegis
const DISPLAY_INFO_STATE = [
  PAGE_STATE.DISPLAY_INFO_NOT_LOGGED_IN,
  PAGE_STATE.DISPLAY_INFO_NOT_IN_PRE_REGIS_PERIOD,
  PAGE_STATE.DISPLAY_INFO_NOT_STUDY_STATUS,
  PAGE_STATE.DISPLAY_INFO_NOT_FIRST_YEAR_FIRST_SEMESTER,
  PAGE_STATE.DISPLAY_INFO_NO_RIGHT,
  PAGE_STATE.DISPLAY_INFO_NEVER_REGIS_AND_AFTER_PRE_REGIS_DATE,
  PAGE_STATE.DISPLAY_INFO_DEFAULT,
];
// สถานะใน PAGE_STATE ที่ใช้การแสดง PreRegistrationPanel
const DISPLAY_REGISTRATION_PANEL_STATE = [
  PAGE_STATE.PRE_REGIS,
  PAGE_STATE.SUMMARY_PRE_REGIS,
];

// import * as dayjs from "dayjs";
import PageInfoPreRegis from "./PageInfoPreRegis.vue";
import PreRegistrationPanel from "./PreRegistrationPanel.vue";

export default {
  name: "PreRegistration",
  components: {
    PageInfoPreRegis,
    PreRegistrationPanel,
  },
  props: {
    selected_year: {
      type: String,
      default: null,
    },
    selected_semester: {
      type: String,
      default: null,
    },
    selected_student_id: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    PAGE_STATE,
    DISPLAY_INFO_STATE,
    DISPLAY_REGISTRATION_PANEL_STATE,
    loading: false,
    error: false,

    level_id: 1, //เฉพาะระดับปริญญาตรี
    year: "2564",
    semester: "1",

    start_pre_regis_date: null,
    end_pre_regis_date: null,

    is_logged_in: false,

    before_pre_regis_date: false, // true ถ้าอยู่ก่อนช่วงลงทะเบียนล่วงหน้า
    on_pre_regis_date: false, // true ถ้าอยู่ในช่วงลงทะเบียนล่วงหน้า
    after_pre_regis_date: false, // true ถ้าอยู่หลังช่วงลงทะเบียนล่วงหน้า

    right_student_status: false, // true ถ้าสถานะเรียนเป็น 'เรียน'
    right_never_regis: false, // true ถ้ายังไม่เคยลงทะเบียนล่วงหน้ามาก่อน
    right_not_first_year_first_semester: true, // true ถ้าไม่ใช่นักศึกษาปี 1 เทอม 1 (ถึงจะลงทะเบียนได้)
    right_not_in_student_no_right: false, // true ถ้าไม่อยู่ในตาราง student_no_right เช่น ไม่มีเงินค้างชำระ

    data_student_no_right: [],
  }),
  computed: {
    student_id() {
      if (this.selected_student_id) return this.selected_student_id;
      return this.$store.state.user.surrogated_student_id;
    },
    // สถานะของหน้าเพจ
    state() {
      // --- Check Login ---
      if (!this.is_logged_in) {
        return PAGE_STATE.DISPLAY_INFO_NOT_LOGGED_IN;
      }

      // --- Check ไม่เป็น นศ. ปีหนึ่ง เทอมแรก ---
      else if (!this.right_not_first_year_first_semester) {
        console.log("state condition: 4");
        return PAGE_STATE.DISPLAY_INFO_NOT_FIRST_YEAR_FIRST_SEMESTER;
      }

      // --- Check วัน ---
      else if (this.before_pre_regis_date) {
        console.log("state condition: 2");
        return PAGE_STATE.DISPLAY_INFO_NOT_IN_PRE_REGIS_PERIOD;
      }

      // --- Check สถานะเรียน ---
      else if (!this.right_student_status) {
        console.log("state condition: 3");
        return PAGE_STATE.DISPLAY_INFO_NOT_STUDY_STATUS;
      }

      // --- Check ไม่อยู่ใน Student no right ---
      else if (!this.right_not_in_student_no_right) {
        console.log("state condition: 5");
        return PAGE_STATE.DISPLAY_INFO_NO_RIGHT;
      }

      // --- Check ยังไม่เคยลงทะเบียน อยู่ในช่วงลงทะเบียน ---
      else if (this.right_never_regis && this.on_pre_regis_date) {
        console.log("state condition: 6");
        return PAGE_STATE.PRE_REGIS;
      }

      // --- Check ยังไม่เคยลงทะเบียน หลังช่วงลงทะเบียน ---
      else if (this.right_never_regis && this.after_pre_regis_date) {
        console.log("state condition: 7");
        return PAGE_STATE.DISPLAY_INFO_NEVER_REGIS_AND_AFTER_PRE_REGIS_DATE;
      }

      // --- Check เคยลงทะเบียนแล้ว ผลยังไม่ออก ---
      else if (!this.right_never_regis) {
        console.log("state condition: 8");
        return PAGE_STATE.SUMMARY_PRE_REGIS;
      } else return PAGE_STATE.DISPLAY_INFO_DEFAULT;
    },
  },
  methods: {
    async get_year_semester() {
      let data;
      if (this.selected_year && this.selected_semester) {
        data = {
          YEAR: this.selected_year,
          SEMESTER: this.selected_semester,
        };
      } else {
        data = await RegistrationService.getYearSemesterNow(
          this.level_id
        ).catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
          this.loading = false;
          this.error = true;
        });
      }
      this.year = data.YEAR;
      this.semester = data.SEMESTER;
    },
    async check_if_logged_in() {
      this.is_logged_in = true;
    },
    async check_date() {
      const data = await RegistrationService.checkRegistrationDateTime({
        level_id: this.level_id,
        year: this.year,
        semester: this.semester,
      }).catch((error) => {
        this.$toasted.error(JSON.stringify(error.response.data.message), {
          duration: 0,
        });
        this.loading = false;
        this.error = true;
      });
      this.before_pre_regis_date = data.pre_regis.before_date;
      this.on_pre_regis_date = data.pre_regis.on_date;
      this.after_pre_regis_date = data.pre_regis.after_date;

      this.start_pre_regis_date = data.pre_regis.start_date;
      this.end_pre_regis_date = data.pre_regis.end_date;
    },
    async check_student_status() {
      const data = await RegistrationService.isStudentStudyStatus(
        this.student_id,
        this.level_id
      ).catch((error) => {
        this.$toasted.error(JSON.stringify(error.response.data.message), {
          duration: 0,
        });
        this.loading = false;
        this.error = true;
      });
      this.right_student_status = data.status;
    },
    async check_never_regis() {
      const data = await RegistrationService.isNeverPreRegis({
        student_id: this.student_id,
        year: this.year,
        semester: this.semester,
        level_id: this.level_id,
      }).catch((error) => {
        this.$toasted.error(JSON.stringify(error.response.data.message), {
          duration: 0,
        });
        this.loading = false;
        this.error = true;
      });
      this.right_never_regis = data.status;
    },
    async check_not_first_year_first_semester() {
      const data = await RegistrationService.isNotSemester1andNotStudentFirst1({
        student_id: this.student_id,
        year: this.year,
        semester: this.semester,
        level_id: this.level_id,
      }).catch((error) => {
        this.$toasted.error(JSON.stringify(error.response.data.message), {
          duration: 0,
        });
        this.loading = false;
        this.error = true;
      });
      this.right_not_first_year_first_semester = data.status;
    },
    async check_not_in_student_no_right() {
      const data = await RegistrationService.checkNotInStudentNoRight({
        student_id: this.student_id,
        year: this.year,
        semester: this.semester,
        level_id: this.level_id,
      }).catch((error) => {
        this.$toasted.error(JSON.stringify(error.response.data.message), {
          duration: 0,
        });
        this.loading = false;
        this.error = true;
      });
      this.right_not_in_student_no_right = data.status;
      if (this.right_not_in_student_no_right == false) {
        this.data_student_no_right = data.data;
      }
    },
    async check_condition() {
      this.loading = true;
      await this.get_year_semester();
      await this.check_if_logged_in();
      await this.check_not_first_year_first_semester();
      await this.check_date();
      await this.check_student_status();
      await this.check_never_regis();
      await this.check_not_in_student_no_right();
      this.loading = false;
    },
  },
  created() {
    this.check_condition();
  },
};
</script>
